export default __webpack_public_path__ + "static/media/banner3.f1c1e8bf.jpg";